import React, { useEffect, useMemo, useRef, useState } from "react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import { FaStar, FaStarHalfAlt, FaTruck } from "react-icons/fa";
import Accordion from "./Accordion";
import { useDispatch, useSelector } from "react-redux";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import api from "../../axios/axios";
// import Warranty from "./Warranty";
// import Spinner from "../..";
import 'quill/dist/quill.snow.css';

// import MeasurementCalculator from "./MeasurementCalculator";
// import WarrantyDetails from "./WarrantyDetails";
// import sanitizeHtml from 'sanitize-html';
import '../../App.css';
import Swal from "sweetalert2";
// import Review from "./Review";
import { setLoading, setProductDetails } from "../../redux/product/productSlice";
import MeasurementCalculator from "./MeasurementCalculator";
import Warranty from "./Warranty";
import Spinner from "../../utils/Spinner";


const ProductDetailPage = () => {
  const {productType,productName}=useParams()
  const navigate = useNavigate(); // Initialize navigate function
  const [isExpanded, setIsExpanded] = useState(false);
  const descriptionRef = useRef(null);

  const handleSeeMoreClick = () => {
    descriptionRef.current.scrollIntoView({ behavior: 'smooth' });
  };

  const dispatch = useDispatch();
  const productDetails = useSelector((state) => state.product.productDetails);
  const loading = useSelector((state) => state.product.loading);

  // states
  const [openAccordion, setOpenAccordion] = useState({}); // Track individual accordion states
  const [colorImage, setColorImage] = useState("");
  const [attributeFrontend, setAttributeFrontend] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [highlightedAttributes, setHighlightedAttributes] = useState({}); // Track highlighted options by attribute
  const [cartDetails,setCartDetails]=useState({
    productId:productDetails?._id||'',
    attributes:[] ,
    totalPrice:Number(productDetails?.price) 
  })
  const [measurementCost,setMeasurementCost]=useState(0)
  const [selectedWarranty, setSelectedWarranty] = useState('1-Year Free Warranty');


  const handleMeasurementCost = (newCost) => {
    
    setMeasurementCost(newCost); // Update the measurement cost
    setCartDetails((prevState) => {
      const previousCost = prevState.totalPrice;
      const updatedTotalPrice = previousCost - measurementCost + newCost; // Subtract old cost and add new cost
      return {
        ...prevState,
        totalPrice: updatedTotalPrice, // Update the total price
      };
    });
  };
  
  const initialAccordionState = useMemo(() => {
    return productDetails?.groupedAttributes
      ? Object.keys(productDetails.groupedAttributes).reduce((acc, key) => {
          acc[key] = true;  
          return acc;
        }, {})
      : {}; 
  }, [productDetails?.groupedAttributes]);

  useEffect(() => {
    setOpenAccordion(initialAccordionState); // Set the accordion state when productDetails are available
  }, [initialAccordionState]);

  
  useEffect(() => {
    let isMounted = true;
  
    const fetchProductDetails = async () => {
      dispatch(setLoading(true));
      try {
        const response = await api.get(`user/getProductDetails/${productType}/${productName}`);
        if (isMounted) {
          dispatch(setProductDetails(response.data));
          setColorImage(response.data.images || "");
          setAttributeFrontend(response.data.groupedAttributes || []); // Handle default values
          setCartDetails((prev) => ({
            ...prev,
            productId: response.data._id || "",
            totalPrice: response.data.price || 0,
          }));
        }
      } catch (error) {
        console.error('Error fetching product details:', error);
        if (isMounted) {
          dispatch(setLoading(false));
      
          // Extract error message safely
          const errorMessage = error.response?.data?.message || 'An unexpected error occurred';
      
          // Show error alert and navigate to home
          Swal.fire({
            icon: 'error',
            title: errorMessage, // Pass the extracted error message
            text: 'Redirecting to home page...',
            confirmButtonText: 'OK',
          }).then(() => {
            navigate('/'); // Redirect to home page after user acknowledges the error
          });
        }
      } finally {
        if (isMounted) dispatch(setLoading(false));
      }
    };
  
    fetchProductDetails();
  
    return () => {
      isMounted = false;
      setColorImage("");
      setCartDetails({
        productId: "",
        attributes: [],
        totalPrice: 0,
      });
      setMeasurementCost(0);
      dispatch(setProductDetails(null));
    };
  }, [dispatch, productType, productName, navigate]); // Added navigate to dependency array
  
  const truncatedDescription = productDetails?.description ? productDetails?.description.slice(0, 200) : '';

  const handleColor = (option,attribute) => {
    const price = Number(option.price);
  
    if (isNaN(price)) {
      return;
    }
  
    setCartDetails((prev) => {
      // Check if an attribute with the same type already exists
      const existingAttribute = prev.attributes.find(
        (attr) => attr.attributeType === option.attributeType
      );
  
      // Calculate the new total price
      const prevTotal = prev.totalPrice || 0;
      const previousPrice = existingAttribute ? Number(existingAttribute.value) || 0 : 0;
      const newTotal = prevTotal - previousPrice + price;
  
  
      // Update the attributes array
      const updatedAttributes = prev.attributes.filter(
        (attr) => attr.attributeType !== option.attributeType
      );
  
      return {
        ...prev, // Spread the previous state
        totalPrice: newTotal,
        attributes: [
          ...updatedAttributes, // Keep attributes of other types
          {
            attributeId: option._id,
            name: option.name, // Update with the new attribute
            value: option.price, // Store the price as value
            image: option.image,
            attributeType: option.attributeType,
          },
        ],
      };
    });
  
    // Update the selected color option
    if (option.attributeType === "color") {
      setSelectedOption(option);
      setColorImage(option.image);
    }
    setHighlightedAttributes((prev) => ({
      ...prev,
      [attribute]: option._id, // Highlight the selected option for the attribute
    }));
  };
  
  

  const toggleAccordion = (attribute) => {
    setOpenAccordion((prev) => ({
      ...prev,
      [attribute]: !prev[attribute], // Toggle specific accordion state
    }));
  };

  if (loading) {
    return <><Spinner/></>;
  } 

;
// const sanitizedDescription = sanitizeHtml(productDetails?.description, {
//   allowedTags: [ 'b', 'i', 'em', 'strong', 'ul', 'ol', 'li', 'p', 'a', 'img' ],
//   allowedAttributes: {
//     '*': ['href', 'target', 'src', 'alt']
//   },
// });


  return (
    <div className="max-w-7xl mx-auto mt-10">
      <div className="bg-white shadow-lg rounded-lg p-8 space-y-8">
        <div className="flex flex-col md:flex-row md:space-x-8">
        <div className="md:w-1/2 ">
        <div className='top-0 sticky h-90vh'> 
        <img
              src={colorImage}
              alt="Traditional Cordless Blackout Cellular Shades "
              className="w-full h-auto rounded-lg sticky "
            />
           
<div className="grid grid-cols-3 gap-4 mt-4 md:flex md:overflow-x-auto md:space-x-4 ">  {productDetails?.groupedAttributes?.color?.map((color, index) => (
    <LazyLoadImage
      key={index}
      src={color.image}
      alt={color.name || `Color ${index + 1}`}
      className="w-30 h-20 object-cover  cursor-pointer border"
      onClick={() => handleColor(color)}
    />
  ))}
   </div> 
</div>

          </div>

          <div className="md:w-1/2 space-y-6">
            <div className="border-[#4961cb] rounded-lg p-4">
              <p className="text-gray-600 mt-2">Signature</p>
              <h1 className="text-3xl font-semibold">
                {productDetails?.productName}
              </h1>

         {/* <Review productId={productDetails?._id}/> */}

              <div className="mt-4">
                <div className="text-3xl font-semibold text-green-600">
                  {productDetails?.price}
                </div>   
                <div className="text-gray-500">for 24" x 36"</div>
              </div>

              <div className="mt-4">
              <span
        className="ql-editor"
        dangerouslySetInnerHTML={{
          __html:  `${truncatedDescription}...`,
        }}
      />
        <span
          className="text-blue-500 hover:text-blue-700 mt-2 cursor-pointer"
          onClick={handleSeeMoreClick}
        > 
          View  More
        </span>
      

    
                <div className="mt-2 text-gray-500 flex items-center">
                  <FaTruck className="mr-2" />
                  Your custom-made shades are estimated to ship in 4 ~ 5 business days.
                </div>
              </div>
            </div>
            
            <div className="border rounded-lg p-4 bg-white shadow-md">
  {productDetails?.groupedAttributes &&
    // Predefined order of attributes
    ["color", "mount_types", "lift_style", "headrail_option"]
      .filter((attribute) => Object.keys(productDetails.groupedAttributes).includes(attribute)) // Ensure the attribute exists
      .map((attribute) => {
        const attributeData = productDetails.groupedAttributes[attribute];
        const attributeType = attributeData[0]?.attributeType;

        return (
          <React.Fragment key={attribute}>
            {/* Render attribute section */}
            <div className="mt-6 first:mt-0">
              <div
                onClick={() => toggleAccordion(attribute)} // Toggle each accordion
                className="flex justify-between items-center cursor-pointer py-3 px-4 bg-gray-100 rounded-lg hover:bg-gray-200 transition-all"
              >
                <span className="text-lg font-medium text-[#24316a]">
                  {attribute.charAt(0).toUpperCase() + attribute.slice(1)}
                </span>
                {openAccordion[attribute] ? (
                  <FaChevronUp className="text-[#24316a]" />
                ) : (
                  <FaChevronDown className="text-[#24316a]" />
                )}
              </div>

              {openAccordion[attribute] && (
                <div className="mt-4 bg-gray-50 rounded-lg p-4 shadow-inner">
                  <p className="text-gray-600 mb-4">
                    Please select a {attributeType || "option"}:
                  </p>

                  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
                    {attributeData.map((option) => (
                      <div
                        onClick={() => handleColor(option, attribute)} // Pass the attribute key here
                        key={option._id}
                        className={`border p-4 rounded-l shadow-lg hover:shadow-xl transition-all cursor-pointer ${
                          highlightedAttributes[attribute] === option._id
                            ? "border-green-500"
                            : "border-gray-300"
                        }`}
                      >
                        

                        <img
                          src={option.attributeImage}
                          alt={option.attributeName}
                          className="w-30 h-30 object-cover  mt-2"
                        />

                        <p className="text-center text-sm text-gray-500 mt-2">
                          {option.attributeName}
                        </p>
                        <p className="text-lg text-center font-semibold text-[#24316a]">
  {option.price === '0' ? 'Free' : `$${option.price}`}
</p> 

                      </div>
                    ))}
                  </div>

                  {/* Render MeasurementCalculator only for "mount_types" */}
                  {attributeType === "mount_types" && (
                    <>
                      <hr />
                      <div className="mt-6">
                        <MeasurementCalculator
                          factor={productDetails?.productFactor}
                          calculationExpression={productDetails?.calculation?.expression}
                          setMeasurement={handleMeasurementCost}
                        />
                      </div>
                    </>
                  )}
                </div>
              )}
            </div>
          </React.Fragment>
        );
      })}
      <div className="border rounded-lg p-4 bg-white shadow-md mt-6">
              <span className="block text-gray-700 font-medium mb-2">Warranty</span>
              <label className="flex items-center space-x-2 mt-2">
                <input
                  type="radio"
                  checked
                  disabled
                  className="form-radio text-blue-600"
                />
                <span className="text-gray-900">1-Year Free Warranty <span className='text-green-600'>( $0.00 )</span></span>
              </label>
            </div>
</div>




{/* <WarrantyDetails/>  */}

<div className="fixed bottom-0 w-full md:right-[0%] right-0 md:w-1/4 z-10 bg-blue-500 shadow-2xl rounded-lg text-white">
  {/* Only render Warranty if cartDetails is ready */}
  {cartDetails && (
    <Warranty cartDetails={cartDetails} selectedWarranty={selectedWarranty} />
  )}
</div>
         </div>
        </div>
      </div>
      <div ref={descriptionRef}>
        {/* If you want to include an Accordion below or any other content */}
        <Accordion />
      
    </div>
    </div>
  );
};

export default ProductDetailPage;